import React, { useState } from "react";
import AppointmentRow from "./AppointmentRow";
import { appointment } from "../../types/calendar";
import { Modal } from "antd";
import AppointmentDetailsModalWrapper from "../calendar/components/AppointmentDetails/AppointmentDetailsModalWrapper";

type Props = {
  appointments: appointment[];
};

const UserAppointments = ({ appointments }: Props) => {
  const [selectedAppointment, setSelectedAppointment] = useState<null | number>(
    null
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  if (!appointments?.length) return null;
  return (
    <div className="py-4 px-3 bg-[#FBFBFF] rounded-lg">
      <h5 className="text-color-primary font-normal text-base mb-4">
        Client Appointments
      </h5>
      <div className="grid gap-2">
        {appointments?.map((appointment, index) => (
          <AppointmentRow
            key={index}
            appointment={appointment}
            onClick={(id) => {
              setSelectedAppointment(id);
              setIsModalOpen(true);
            }}
          />
        ))}
      </div>
      <Modal
        width={700}
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          setSelectedAppointment(null);
        }}
        footer={null}
        destroyOnClose
      >
        <AppointmentDetailsModalWrapper
          setIsModalOpen={setIsModalOpen}
          appointment={
            {
              id: selectedAppointment,
            } as any
          }
        />
      </Modal>
    </div>
  );
};

export default UserAppointments;
